module.exports = __webpack_public_path__ + "img/batch-import.051e8e7a.svg";